@if (href) {
  <a [class]="classes" [href]="href" [attr.target]="target" (click)="click()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else if (route) {
  <a [class]="classes" [routerLink]="route" [queryParams]="params" [fragment]="fragment" (click)="click()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </a>
} @else {
  <span [class]="classes" (click)="click()">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </span>
}

<ng-template #content>
  @if (arrow === 'left') {
    <app-icon class="link__left-arrow" [icon]="'chevron'" [height]="12" [rotate]="180"></app-icon>
  }
  <span class="link__content">
    <ng-content></ng-content>
  </span>
  @if (arrow && arrow !== 'left') {
    <app-icon class="link__{{ arrow }}-arrow" [icon]="arrow == 'right' ? 'chevron' : 'arrow'" [height]="arrow == 'right' ? 12 : 8" [rotate]="arrow === 'top' ? 270 : arrow === 'bottom' ? 90 : undefined"></app-icon>
  }
</ng-template>
